import { NavLink, Outlet, useNavigate, Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { LayoutDashboard, Newspaper, FolderKanban, Star, Briefcase, Package, Wrench, FileText, Receipt, FileSpreadsheet, Settings, LogOut, Flower2, KeyRound, Home } from "lucide-react";

const groups = [
  { title: "Utama", items: [{ to: "/admin", label: "Dashboard", icon: LayoutDashboard, end: true }] },
  { title: "Konten Situs", items: [
    { to: "/admin/berita", label: "Berita", icon: Newspaper },
    { to: "/admin/portofolio", label: "Portofolio", icon: FolderKanban },
    { to: "/admin/testimoni", label: "Testimoni", icon: Star },
    { to: "/admin/karir", label: "Lowongan Karir", icon: Briefcase },
    { to: "/admin/produk", label: "Produk", icon: Package },
    { to: "/admin/layanan", label: "Layanan", icon: Wrench },
  ]},
  { title: "Dokumen", items: [
    { to: "/admin/cop-surat", label: "Cop Surat", icon: FileText },
    { to: "/admin/invoice", label: "Invoice", icon: FileSpreadsheet },
    { to: "/admin/kwitansi", label: "Kwitansi", icon: Receipt },
  ]},
  { title: "Pengaturan", items: [
    { to: "/admin/pengaturan", label: "Info Perusahaan", icon: Settings },
    { to: "/admin/ganti-password", label: "Ganti Password", icon: KeyRound },
  ]},
];

export default function AdminLayout() {
  const { user, loading, logout } = useAuth();
  const nav = useNavigate();
  if (loading) return <div className="min-h-screen bg-[#07080B] flex items-center justify-center text-gold">Memuat…</div>;
  if (!user) return <Navigate to="/admin/login" replace />;

  return (
    <div className="min-h-screen bg-[#07080B] flex">
      <aside className="w-64 bg-[#0F1117] border-r border-amber-500/15 flex flex-col fixed inset-y-0 overflow-y-auto z-40">
        <div className="p-5 flex items-center gap-2.5 border-b border-amber-500/15">
          <Flower2 className="w-7 h-7 text-gold" strokeWidth={1.6} />
          <div><div className="font-syne font-extrabold gold-gradient-text leading-none">LOTUS</div><div className="text-[10px] tracking-[0.3em] text-white/50">ADMIN</div></div>
        </div>
        <nav className="flex-1 p-3 space-y-4">
          {groups.map((g) => (
            <div key={g.title}>
              <div className="text-[10px] uppercase tracking-widest text-white/30 px-3 mb-1">{g.title}</div>
              {g.items.map((it) => (
                <NavLink key={it.to} to={it.to} end={it.end} data-testid={`admin-nav-${it.label.toLowerCase().replace(/\s+/g, "-")}`}
                  className={({ isActive }) => `flex items-center gap-3 px-3 py-2.5 rounded-lg text-sm transition-colors ${isActive ? "btn-gold" : "text-white/70 hover:bg-white/5"}`}>
                  <it.icon className="w-4 h-4" /> {it.label}
                </NavLink>
              ))}
            </div>
          ))}
        </nav>
        <div className="p-3 border-t border-amber-500/15 space-y-1">
          <a href="/" target="_blank" rel="noreferrer" className="flex items-center gap-3 px-3 py-2.5 rounded-lg text-sm text-white/70 hover:bg-white/5"><Home className="w-4 h-4" /> Lihat Situs</a>
          <button onClick={() => { logout(); nav("/admin/login"); }} className="w-full flex items-center gap-3 px-3 py-2.5 rounded-lg text-sm text-red-400 hover:bg-red-500/10" data-testid="admin-logout"><LogOut className="w-4 h-4" /> Keluar</button>
        </div>
      </aside>
      <main className="flex-1 ml-64 p-6 lg:p-10">
        <Outlet />
      </main>
    </div>
  );
}
